import React from 'react';
import { useTranslation } from 'react-i18next';

const TestCustomersList = ({ customers }) => {
  const { t } = useTranslation('ChatbotIA');

  if (!customers.length) {
    return (
      <p className="tw-mb-0 tw-text-sm tw-text-gray-500">
        {t('config.test_customers.empty')}
      </p>
    );
  }

  return (
    <ul className="tw-flex tw-flex-wrap tw-gap-2 tw-max-h-40 tw-overflow-y-auto tw-pl-0 tw-mb-0 tw-list-none">
      {customers.map((customer) => (
        <li
          key={customer.id}
          title={customer.label}
          className="tw-inline-flex tw-max-w-full tw-items-center tw-rounded-full tw-border tw-border-gray-200 tw-bg-gray-50 tw-px-3 tw-py-1 tw-text-xs tw-text-gray-800"
        >
          <span className="tw-truncate">
            {customer.name || customer.label}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default TestCustomersList;
